import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { mutate } from 'swr'
import { CS } from 'back-end-api'
import { getActiveAppointmentFromSummary } from 'services/Registrations'

export type PatientRouteParams = {
  id: string
}

export const usePatientRouteParams = () => {
  const { id } = useParams<PatientRouteParams>()
  const registrationRes = CS.useRegistration({ id }, { refreshInterval: 5000 })
  const registration = registrationRes.data
  const summary = CS.getSummary(registration)
  const appointment = getActiveAppointmentFromSummary(summary)

  // Trigger SWR revalidation for this registration's cache key.
  // Uses the same key pattern as the Registrations module internally.
  const mutateRegistration = useCallback(() => {
    mutate(`swrRegistration_${id}`)
  }, [id])

  return { registrationRes, registration, summary, appointment, mutateRegistration }
}
